var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("參數設定")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("會員介面設定")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("會員介面設定")])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, _vm._l(_vm.colorMap, function (i, idx) {
    return _c('b-form-group', {
      key: idx,
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "4",
        "label-size": "sm",
        "label": i.text,
        "label-class": "font-weight-bold text-lg-right"
      }
    }, [_c('color-picker', {
      model: {
        value: _vm.setColorObject[i.key],
        callback: function callback($$v) {
          _vm.$set(_vm.setColorObject, i.key, $$v);
        },
        expression: "setColorObject[i.key]"
      }
    }), _c('div', [_vm._v(_vm._s(i.name))])], 1);
  }), 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_vm.moduleConfig ? _c('UIReview', {
    attrs: {
      "moduleConfig": _vm.moduleConfig,
      "tabs": _vm.tabs,
      "colorObject": _vm.setColorObject
    }
  }) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-center mt-3"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")]), _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "success",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function click($event) {
        return _vm.handleSubmit(false);
      }
    }
  }, [_vm._v(" 儲存 ")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" 儲存後關閉 ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }